// extracted by mini-css-extract-plugin
module.exports = {"section":"O_section__GiI9q"};